<div class="buscador">
  <!-- Tagline con gradiente (Figma: Phindi/Display 2) -->
  <h1 class="tagline">{{ tagline() }}</h1>

  <!-- Barra de filtros (Figma: search bar) — RN02: aplica a grilla y mapa.
       En mobile se convierte en hoja desplegable (Figma 157-762). -->
  <section
    class="barra-filtros"
    [class.barra-filtros--abierta]="filtrosAbiertos()"
    aria-label="Filtros de búsqueda"
  >
    <div class="sheet-header">
      <span class="sheet-header__titulo">Filtros</span>
      <button
        type="button"
        class="sheet-header__cerrar"
        (click)="filtrosAbiertos.set(false)"
        aria-label="Cerrar filtros"
      >
        ✕
      </button>
    </div>
    @if (panelAbierto()) {
      <div
        class="backdrop"
        (click)="cerrarPaneles()"
        aria-hidden="true"
      ></div>
    }

    <div class="filtros">
      <!-- Categoría -->
      <div class="filtro">
        <button
          type="button"
          class="filtro__btn"
          (click)="togglePanel('categoria')"
          [attr.aria-expanded]="panelAbierto() === 'categoria'"
        >
          <span class="filtro__label">Categoría<span class="chevron" [class.chevron--abierto]="panelAbierto() === 'categoria'"><svg app-icono nombre="chevron-down"></svg></span></span>
          <span class="filtro__valor">{{ labelCategoria() }}</span>
        </button>
        @if (panelAbierto() === 'categoria') {
          <div class="panel">
            <button type="button" class="panel__opcion" (click)="setCategoria(undefined)">
              Todas
            </button>
            @for (tipo of tiposPropiedad; track tipo) {
              <button
                type="button"
                class="panel__opcion"
                [class.panel__opcion--activa]="borrador().tipoPropiedad === tipo"
                (click)="setCategoria(tipo)"
              >
                {{ tipoLabels[tipo] }}
              </button>
            }
            <!-- Caso especial: flag de emprendimiento presentado como categoría -->
            <button
              type="button"
              class="panel__opcion"
              [class.panel__opcion--activa]="borrador().emprendimiento"
              (click)="setCategoriaEmprendimientos()"
            >
              Emprendimientos
            </button>
          </div>
        }
      </div>

      <span class="divisor" aria-hidden="true"></span>

      <!-- Operación -->
      <div class="filtro">
        <button
          type="button"
          class="filtro__btn"
          (click)="togglePanel('operacion')"
          [attr.aria-expanded]="panelAbierto() === 'operacion'"
        >
          <span class="filtro__label">Operación<span class="chevron" [class.chevron--abierto]="panelAbierto() === 'operacion'"><svg app-icono nombre="chevron-down"></svg></span></span>
          <span class="filtro__valor">{{ labelOperacion() }}</span>
        </button>
        @if (panelAbierto() === 'operacion') {
          <div class="panel">
            <button type="button" class="panel__opcion" (click)="setOperacion(undefined)">
              Todas
            </button>
            @for (op of operaciones; track op) {
              <button
                type="button"
                class="panel__opcion"
                [class.panel__opcion--activa]="borrador().operacion === op"
                (click)="setOperacion(op)"
              >
                {{ operacionLabels[op] }}
              </button>
            }
          </div>
        }
      </div>

      <span class="divisor" aria-hidden="true"></span>

      <!-- Ubicación -->
      <div class="filtro">
        <button
          type="button"
          class="filtro__btn"
          (click)="togglePanel('ubicacion')"
          [attr.aria-expanded]="panelAbierto() === 'ubicacion'"
        >
          <span class="filtro__label">Ubicación<span class="chevron" [class.chevron--abierto]="panelAbierto() === 'ubicacion'"><svg app-icono nombre="chevron-down"></svg></span></span>
          <span class="filtro__valor">{{ labelUbicacion() }}</span>
        </button>
        @if (panelAbierto() === 'ubicacion') {
          <!-- Multi-zona (DP02/DP03): cada zona agregada queda como chip -->
          <div class="panel panel--form">
            <label class="panel__campo">
              Localidad
              <!-- FP-16: sugerencias de GET /localidades?q=. Sigue aceptando
                   texto libre (el catálogo es abierto). -->
              <app-autocomplete-localidad (elegida)="agregarZona($event)" />
            </label>
            <!-- Sin botón "Agregar": la zona se suma al elegir una sugerencia
                 o con Enter sobre el texto tipeado. -->
            @if (zonas().length) {
              <ul class="zonas" aria-label="Zonas seleccionadas">
                @for (zona of zonas(); track zona) {
                  <li class="zonas__chip">
                    {{ zona }}
                    <button
                      type="button"
                      class="zonas__quitar"
                      (click)="quitarLocalidad(zona)"
                      [attr.aria-label]="'Quitar ' + zona"
                    >
                      ✕
                    </button>
                  </li>
                }
              </ul>

              <!-- FP-50: el mismo enlace rosa subrayado que el "Limpiar
                   localidades" del backoffice (`localidad-filter`), y con el
                   filtro nombrado como en "Limpiar precio". Aparece sólo con
                   zonas elegidas: sin ninguna no hay nada que limpiar. -->
              <button
                type="button"
                class="panel__limpiar"
                (click)="limpiarLocalidades()"
              >
                Limpiar ubicación
              </button>
            } @else {
              <!-- Mismo pie que el localidad-filter del backoffice: con el
                   panel vacío, en vez del botón va la ayuda que explica cómo
                   se suma una zona. -->
              <p class="panel__hint">Elegí una sugerencia o escribí la zona.</p>
            }
          </div>
        }
      </div>

      <span class="divisor" aria-hidden="true"></span>

      <!-- Precio -->
      <div class="filtro">
        <button
          type="button"
          class="filtro__btn"
          (click)="togglePanel('precio')"
          [attr.aria-expanded]="panelAbierto() === 'precio'"
        >
          <span class="filtro__label">Precio<span class="chevron" [class.chevron--abierto]="panelAbierto() === 'precio'"><svg app-icono nombre="chevron-down"></svg></span></span>
          <span class="filtro__valor">{{ labelPrecio() }}</span>
        </button>
        @if (panelAbierto() === 'precio') {
          <!-- Mismo layout que el `price-panel` del backoffice: moneda con
               radios, slider y "Limpiar precio". Sin "Aplicar": el filtro se
               aplica con Buscar, igual que todos los demás (FP-39). -->
          <div class="panel price-panel">
            <div class="price-currency">
              <span class="currency-label">Moneda</span>
              <div class="currency-options">
                @for (m of monedas; track m) {
                  <app-input-radio
                    [label]="m === Moneda.USD ? 'USD' : 'ARS'"
                    name="precio-moneda"
                    [checked]="precioMoneda() === m"
                    (cambio)="setPrecioMoneda(m)"
                  />
                }
              </div>
            </div>

            <!-- Los topes salen de GET rango-precios (BP-01). Sin moneda el
                 filtro está inactivo y el slider va deshabilitado. -->
            <app-slider-precio
              [min]="extremosPrecio().min"
              [max]="extremosPrecio().max"
              [step]="precioStep()"
              [disabled]="!precioMoneda() || !hayRango()"
              [simbolo]="precioMoneda() === Moneda.USD ? 'U$S' : '$'"
              [desde]="sliderDesde()"
              [hasta]="sliderHasta()"
              (desdeChange)="onPrecioDesde($event)"
              (hastaChange)="onPrecioHasta($event)"
            />

            @if (!precioMoneda()) {
              <p class="price-hint">
                Elegí una moneda para habilitar el rango de precios.
              </p>
            } @else if (!hayRango()) {
              <!-- La combinación operación + moneda no tiene ninguna propiedad
                   publicada. Se dice, en vez de ofrecer el techo de respaldo
                   como si fuera un rango real. -->
              <p class="price-hint">
                No hay propiedades con precio en {{ precioMoneda() }} para esa
                operación.
              </p>
              <button type="button" class="price-clear" (click)="limpiarPrecio()">
                Limpiar precio
              </button>
            } @else {
              <button type="button" class="price-clear" (click)="limpiarPrecio()">
                Limpiar precio
              </button>
            }
          </div>
        }
      </div>

      <!-- Filtro numérico dinámico (FP-38): Dormitorios, Ambientes o
           Superficie según la categoría elegida en el borrador. Con "Todas",
           "Especial" o "Emprendimientos" no se muestra (D12), y con él se va
           su divisor. -->
      @if (caracteristica()) {
        <span class="divisor" aria-hidden="true"></span>

        <div class="filtro">
          <button
            type="button"
            class="filtro__btn"
            (click)="togglePanel('ambientes')"
            [attr.aria-expanded]="panelAbierto() === 'ambientes'"
          >
            <span class="filtro__label">{{ labelCaracteristica()
              }}<span class="chevron" [class.chevron--abierto]="panelAbierto() === 'ambientes'"><svg app-icono nombre="chevron-down"></svg></span></span>
            <span class="filtro__valor">{{
              esFiltroPorSuperficie() ? labelSuperficie() : labelAmbientes()
            }}</span>
          </button>

          @if (panelAbierto() === 'ambientes') {
            @if (esFiltroPorCantidad()) {
              <div class="panel">
                <button type="button" class="panel__opcion" (click)="setAmbientes(undefined)">
                  Todos
                </button>
                @for (n of opcionesAmbientes; track n) {
                  <button
                    type="button"
                    class="panel__opcion"
                    [class.panel__opcion--activa]="borrador().ambientes === n"
                    (click)="setAmbientes(n)"
                  >
                    {{ n >= ambientesMasDe ? '+' + ambientesMasDe : n }}
                  </button>
                }
              </div>
            } @else {
              <!-- Tope FIJO en 3000 m² (no hay endpoint de extremos). Por eso
                   la banda no viaja hasta que el usuario toca el slider, y
                   `superficieMax` se omite si quedó arriba: si no, una
                   propiedad mayor a 3000 quedaría escondida. -->
              <div class="panel price-panel">
                <app-slider-precio
                  [min]="0"
                  [max]="superficieMax"
                  [step]="superficieStep"
                  simbolo=""
                  magnitud="Superficie"
                  [desde]="superficieSliderDesde()"
                  [hasta]="superficieSliderHasta()"
                  (desdeChange)="onSuperficieDesde($event)"
                  (hastaChange)="onSuperficieHasta($event)"
                />
                <p class="price-hint">
                  Medidas en m². El filtro se aplica con "Buscar".
                </p>
                @if (superficieTocada()) {
                  <button type="button" class="price-clear" (click)="limpiarSuperficie()">
                    Limpiar superficie
                  </button>
                }
              </div>
            }
          }
        </div>
      }
    </div>

    <!-- FP-39: único punto que convierte el borrador en búsqueda. Elegir un
         filtro sólo lo anota; nada se pide hasta que se acciona este botón.
         El desplegable NO se cierra al buscar (lo resuelve `aplicarYBuscar`),
         pero la hoja de filtros de mobile sí: mismo criterio que el backoffice,
         donde el Buscar del panel mobile hace `search()` + `cerrarPanel()`. -->
    <button
      type="button"
      class="btn-buscar"
      [disabled]="!huboInteraccion()"
      (click)="aplicarYBuscar(); filtrosAbiertos.set(false)"
    >
      Buscar
    </button>
  </section>

  <!-- Banner publicitario: franja superior (BP-02 / FP-27, spec §17) -->
  @if (bannerSuperior(); as banner) {
    <app-banner-cta [banner]="banner" />
  }

  <!-- Resultados + alternador de vista (FE-01) -->
  <div class="resultados-header">
    <p class="resultados-texto">
      Encontramos <strong>{{ totalResultadosLabel() }}</strong> para tu
      búsqueda
      <!-- Término del buscador del toolbar (DP08) -->
      @if (terminoBusqueda(); as termino) {
        <span class="termino-chip">
          “{{ termino }}”
          <button
            type="button"
            class="termino-chip__quitar"
            (click)="quitarBusqueda()"
            aria-label="Quitar búsqueda"
          >
            ✕
          </button>
        </span>
      }
    </p>
    <!-- Mobile: abre la hoja de filtros (Figma 157-762) -->
    <button
      type="button"
      class="btn-filtros"
      (click)="filtrosAbiertos.set(true)"
    >
      Filtros
      <svg app-icono nombre="filter"></svg>
    </button>
    <button type="button" class="btn-vista" (click)="toggleVista()">
      {{ vista() === 'mapa' ? 'Ver grilla' : 'Ver mapa' }}
      <svg app-icono nombre="apps"></svg>
    </button>
  </div>

  <!-- Estado de error (FE-07) -->
  @if (errorBusqueda()) {
    <div class="error-busqueda" role="alert">
      No pudimos cargar los resultados. Revisá tu conexión e intentá de nuevo.
      <button type="button" class="error-busqueda__btn" (click)="buscar()">
        Reintentar
      </button>
    </div>
  }

  <!-- Vista mapa -->
  @if (vista() === 'mapa') {
    <app-mapa-propiedades
      [pines]="pinesFiltrados()"
      [total]="totalResultados()"
      [truncado]="mapaTruncado()"
      [localidades]="zonasAplicadas()"
      [encuadre]="encuadre()"
      [cargando]="cargandoMapa()"
      [camaraInicial]="camaraInicial"
      [pinInicial]="pinInicial"
      (boundsChange)="onBoundsChange($event)"
      (camaraChange)="onCamaraChange($event)"
      (seleccionChange)="onSeleccionChange($event)"
    />
  } @else {
    <!-- Vista grilla -->
    @if (cargandoLista()) {
      <p class="estado">Cargando propiedades…</p>
    } @else if (!propiedadesGrilla().length) {
      <p class="estado">
        No encontramos propiedades para tu búsqueda. Probá ajustando los
        filtros.
      </p>
    } @else {
      <div class="grilla">
        @for (
          propiedad of propiedadesGrilla();
          track propiedad.id;
          let i = $index
        ) {
          <app-propiedad-card
            [propiedad]="propiedad"
            [fotos]="propiedad.galeria"
          />
          <!-- Banner intercalado tras la 2da fila (Figma: `banner 1`,
               27:654; FP-19). Sólo si hay una 3ra fila: si la 6ta propiedad
               es la última, no tiene sentido cortar la grilla ahí. -->
          @if (
            i === 5 && propiedadesGrilla().length > 6 && bannerInferior();
            as banner
          ) {
            <app-banner-cta [banner]="banner" class="grilla__banner" />
          }
        }
      </div>

      @if (lista(); as l) {
        <div class="paginacion">
          <span class="paginacion__info">{{ infoPaginacion() }}</span>
          <app-paginador
            [paginaActual]="l.pagina"
            [totalPaginas]="l.totalPaginas"
            (cambioPagina)="irAPagina($event)"
          />
        </div>
      }
    }
  }
</div>
